import { Client } from "@planningcenter/api-client"

const apiClients = {}

const useApiClient = (app, version = null) => {
  const key = `${app}/${version}`
  apiClients[key] = apiClients[key] || new Client({ app, version })
  return apiClients[key]
}

export default useApiClient
